import Loadable from "@loadable/component";
import Loading from "../system/views/loading.jsx";

/** DASHBOARD */
const Dashboard = Loadable(() =>
  import(/* webpackChunkName: "view-dashboard" */ "./views/dashboard.jsx")
);

/** ANAGRAFICA CLIENTE */
const ClientiArchivio = Loadable(() =>
  import(/* webpackChunkName: "view-clienti-archivio" */ "./views/clienti/clientiArchivio.jsx")
);

const ClientiDettaglio = Loadable(() =>
  import(/* webpackChunkName: "view-clienti-dettaglio" */ "./views/clienti/clientiDettaglio.jsx")
);

/** ORDINI */
const OrdiniArchivio = Loadable(() =>
  import(/* webpackChunkName: "view-ordini-archivio" */ "./views/ordini/ordiniArchivio.jsx")
);

const OrdiniAttivi = Loadable(() =>
  import(/* webpackChunkName: "view-ordini-attivi" */ "./views/ordini/ordiniAttivi.jsx")
);

const OrdiniCampioni = Loadable(() =>
  import(/* webpackChunkName: "view-ordini-campioni" */ "./views/ordini/ordiniCampioni.jsx")
);

const ArchiviOrdiniESostituzioniConNoteDaLeggere = Loadable(() =>
  import(
    /* webpackChunkName: "view-archivio-note-da-leggere" */ "./views/ordini-e-sostituzioni/archivioNoteDaLeggere.jsx"
  )
);

const ArchiviOrdiniESostituzioniDaConfermare = Loadable(() =>
  import(
    /* webpackChunkName: "view-archivio-da-confermare" */ "./views/ordini-e-sostituzioni/archivioDaConfermare.jsx"
  )
);

const OrdiniNoteAssistenza = Loadable(() =>
  import(/* webpackChunkName: "view-note-assistenza" */ "./views/ordini/noteassistenza.jsx")
);

const OrdiniGaranzieDaAttivare = Loadable(() =>
  import(
    /* webpackChunkName: "view-garanzie-da-attivare" */ "./views/ordini/garanziedaattivare.jsx"
  )
);

const OrdiniDettaglio = Loadable(() =>
  import(
    /* webpackChunkName: "view-ordini-dettaglio" */ "./views/ordini/dettaglio/ordiniDettaglio.jsx"
  )
);

const OrdiniTickets = Loadable(() =>
  import(
    /* webpackChunkName: "view-ordini-tickets" */ "./views/ordini/tickets/ordiniTickets.jsx"
  )
);

const ConfermaOtpRichiestaConfermaOrdine = Loadable(() =>
  import(
    /* webpackChunkName: "view-richiesta-conferma-otp" */ "./views/standalone/richiestaConfermaOtp.jsx"
  )
);

const ConfermaEldomOutOfstock = Loadable(() =>
  import(
    /* webpackChunkName: "view-eldom-out-of-stock" */ "./views/standalone/eldomOutOfStock.jsx"
  )
);

const OrderTracking = Loadable(() =>
  import(
    /* webpackChunkName: "view-order-tracking" */ "./views/standalone/orderTracking.jsx"
  )
);

const DamageReportComponentsList = Loadable(() =>
  import(
    /* webpackChunkName: "view-damage-report-component-list" */ "./views/standalone/damageReportComponentsList.jsx"
  )
);

const DamageReportDetail = Loadable(() =>
  import(
    /* webpackChunkName: "view-damage-report-detail" */ "./views/standalone/damageReportDetail.jsx"
  )
);

/** EXPO */
const Expo = Loadable(() =>
  import(/* webpackChunkName: "view-ordini-expo" */ "./views/ordini/ordiniExpo.jsx")
);

/** PREVISIONI  SPEDIZIONI */
const PrevisioneSpedizioniArchivio = Loadable(() =>
  import(
    /* webpackChunkName: "view-previsione-spedizione-archivio" */ "./views/ordini/previsioneSpedizioneArchivio.jsx"
  )
);

/** POST VENDITA */
const ReclamiArchivio = Loadable(() =>
  import(
    /* webpackChunkName: "view-reclami-archivio" */ "./views/post-vendita/reclami/reclamiArchivio.jsx"
  )
);

const ReclamiDettaglio = Loadable(() =>
  import(
    /* webpackChunkName: "view-reclamo-dettaglio" */ "./views/post-vendita/reclami/dettaglio/reclamoDettaglio.jsx"
  )
);

const ReclamiNuovoReclamo = Loadable(() =>
  import(
    /* webpackChunkName: "view-nuovo-reclamo" */ "./views/post-vendita/reclami/nuovoReclamo.jsx"
  )
);

const SegnalazioneNuovoDanno = Loadable(() =>
  import(
    /* webpackChunkName: "view-nuova-segnalazione" */ "./views/post-vendita/segnalazioni/nuovaSegnalazione.jsx"
  )
);

const SostituzioniArchivio = Loadable(() =>
  import(
    /* webpackChunkName: "view-sostituzioni-archivio" */ "./views/post-vendita/sostituzioni/sostituzioniArchivio.jsx"
  )
);

const SostituzioniAttive = Loadable(() =>
  import(
    /* webpackChunkName: "view-sostituzioni-attive" */ "./views/post-vendita/sostituzioni/sostituzioniAttive.jsx"
  )
);

const FattureNoteAccredito = Loadable(() =>
  import(
    /* webpackChunkName: "view-note-accredito" */ "./views/post-vendita/noteAccredito.jsx"
  )
);

const AutorizzazioniReso = Loadable(() =>
  import(
    /* webpackChunkName: "view-autorizzazioni-reso" */ "./views/post-vendita/autorizzazioniReso.jsx"
  )
);

const ConfermaOtpAap = Loadable(() =>
  import(
    /* webpackChunkName: "view-richiesta-conferma-otp" */ "./views/standalone/richiestaConfermaOtp.jsx"
  )
);

/** ECOMMERCE */
const ListaProdotti = Loadable(() =>
  import(/* webpackChunkName: "view-lista-prodotti" */ "./views/ecommerce/listaProdotti.jsx")
);

const DettaglioProdotto = Loadable(() =>
  import(/* webpackChunkName: "view-dettaglio-prodotto" */ "./views/ecommerce/dettaglioProdotto.jsx")
);

const Carrello = Loadable(() =>
  import(/* webpackChunkName: "view-carrello" */ "./views/ecommerce/carrello.jsx")
);

const StoricoCarrelli = Loadable(() =>
  import(/* webpackChunkName: "view-storico-carrelli" */ "./views/ecommerce/storicoCarrelli.jsx")
);

const StoricoCarrelloDettaglio = Loadable(() =>
  import(/* webpackChunkName: "view-storico-carrello-dettaglio" */ "./views/ecommerce/storicoCarrelloDettaglio.jsx")
);

/** COMMECIALE */
const CommleListaProdottiMarketing = Loadable(() =>
  import(/* webpackChunkName: "view-products-list-marketing" */ "./views/commerciale/productsList.jsx")
);

const CommleListaProdottiOmaggio = Loadable(() =>
  import(/* webpackChunkName: "view-products-list-gift" */ "./views/commerciale/productsList.jsx")
);

const CommleCarrelloOmaggi = Loadable(() =>
  import(/* webpackChunkName: "view-cart-gift" */ "./views/commerciale/cart.jsx")
);

const CommleCarrelloMarketing = Loadable(() =>
  import(/* webpackChunkName: "view-cart-marketing" */ "./views/commerciale/cart.jsx")
);

const CommleCarrelloCampionari = Loadable(() =>
  import(/* webpackChunkName: "view-cart-contracts" */ "./views/commerciale/cart.jsx")
);

const CommleListaProdottiCampionarioAnte = Loadable(() =>
  import(/* webpackChunkName: "view-product-list-doors" */ "./views/commerciale/productsList.jsx")
);

const CommleCarrelloAnte = Loadable(() =>
  import(/* webpackChunkName: "view-cart-doors" */ "./views/commerciale/cart.jsx")
);

const CommleListaContrattiCampionari = Loadable(() =>
  import(/* webpackChunkName: "view-contract-list" */ "./views/commerciale/campionari/contractsList.jsx")
);

const CommleListaProdottiCampionari = Loadable(() =>
  import(/* webpackChunkName: "view-product-list-contracts" */ "./views/commerciale/productsList.jsx")
);

const CommleListaOrdiniOggettistica = Loadable(() =>
  import(/* webpackChunkName: "view-order-list-furniture" */ "./views/commerciale/oggettistica/ordersList.jsx")
);

const CommleListaProdottiOggettistica = Loadable(() =>
  import(/* webpackChunkName: "view-product-list-furniture" */ "./views/commerciale/productsList.jsx")
);

const CommleCarrelloOggettistica = Loadable(() =>
  import(/* webpackChunkName: "view-cart-furniture" */ "./views/commerciale/cart.jsx")
);

const CommleCarrelloParzialeOggettistica = Loadable(() =>
  import(/* webpackChunkName: "view-partial-cart-furniture" */ "./views/commerciale/cart.jsx")
);

const CommleCarrelloStoricoOrdini = Loadable(() =>
  import(/* webpackChunkName: "view-order-history" */ "./views/commerciale/cartsList.jsx")
);

const CommleDistribuzioneOrdiniPopLista = Loadable(() =>
  import(/* webpackChunkName: "view-order-pop-list" */ "./views/commerciale/distroPopList.jsx")
);

const CommleDistribuzioneOrdiniPopListaDettaglio = Loadable(() =>
  import(/* webpackChunkName: "view-order-pop-list-details" */ "./views/commerciale/distroPopListDetails.jsx")
);

/** AMMINISTRAZIONE */
const FattureArchivio = Loadable(() =>
  import(
    /* webpackChunkName: "view-fatture-archivio" */ "./views/amministrazione/fattureArchivio.jsx"
  )
);

const DdtArchivio = Loadable(() =>
  import(
    /* webpackChunkName: "view-ddt-archivio" */ "./views/amministrazione/ddtArchivio.jsx"
  )
);

/** PROMO */
const PromozioniArchivio = Loadable(() =>
  import(
    /* webpackChunkName: "view-promozioni-archivio" */ "./views/promozioni/promozioniArchivio.jsx"
  )
);

/** VIRTUAL TOUR */
const VirtualTourScorze = Loadable(() =>
  import(
    /* webpackChunkName: "view-virtualtour-scorze" */ "./views/virtualtour/virtualtour-scorze.jsx"
  )
);

const VirtualTourMilano = Loadable(() =>
  import(
    /* webpackChunkName: "view-virtualtour-milano" */ "./views/virtualtour/virtualtour-milano.jsx"
  )
);

/** AREA TECNICA */
const SchedeMontaggioHome = Loadable(() =>
  import(
    /* webpackChunkName: "view-schede-montaggio" */ "./views/area-tecnica/schede-montaggio/schedeMontaggio.jsx"
  )
);

const SchedeMontaggioCategory = Loadable(() =>
  import(
    /* webpackChunkName: "view-schede-montaggio-category" */ "./views/area-tecnica/schede-montaggio/schedeMontaggioCategory.jsx"
  )
);

const SchedeMontaggioPdf = Loadable(() =>
  import(
    /* webpackChunkName: "view-schede-montaggio-pdf" */ "./views/area-tecnica/schede-montaggio/schedeMontaggioPdf.jsx"
  )
);

const SchedeMontaggioVideo = Loadable(() =>
  import(
    /* webpackChunkName: "view-schede-montaggio-video" */ "./views/area-tecnica/schede-montaggio/schedeMontaggioVideo.jsx"
  )
);

const ManualiTecnici = Loadable(() =>
  import(
    /* webpackChunkName: "view-manuali-tecnici" */ "./views/area-tecnica/manuali-tecnici/manualiTecnici.jsx"
  )
);

const ManualiTecniciCategory = Loadable(() =>
  import(
    /* webpackChunkName: "view-manuali-tecnici-category" */ "./views/area-tecnica/manuali-tecnici/manualiTecniciCategory.jsx"
  )
);

const ManualiTecniciPdf = Loadable(() =>
  import(
    /* webpackChunkName: "view-manuali-tecnici-pdf" */ "./views/area-tecnica/manuali-tecnici/manualiTecniciPdf.jsx"
  )
);

const ManualiTecniciVideo = Loadable(() =>
  import(
    /* webpackChunkName: "view-manuali-tecnici-video" */ "./views/area-tecnica/manuali-tecnici/manualiTecniciVideo.jsx"
  )
);

const ManualiTecniciGallery = Loadable(() =>
  import(
    /* webpackChunkName: "view-manuali-tecnici-gallery" */ "./views/area-tecnica/manuali-tecnici/manualiTecniciGallery.jsx"
  )
);

const Finiture = Loadable(() =>
  import(
    /* webpackChunkName: "view-finiture" */ "./views/area-tecnica/finiture/finiture.jsx"
  )
);

const FinitureAnte = Loadable(() =>
  import(
    /* webpackChunkName: "view-doors" */ "./views/area-tecnica/finiture/finitureAnte.jsx"
  )
);

const FinitureTop = Loadable(() =>
  import(
    /* webpackChunkName: "view-top" */ "./views/area-tecnica/finiture/finitureTop.jsx"
  )
);

const FinitureAnteModello = Loadable(() =>
  import(
    /* webpackChunkName: "view-model-doors" */ "./views/area-tecnica/finiture/finitureAnteModello.jsx"
  )
);

const SchedaProdotto = Loadable(() =>
  import(
    /* webpackChunkName: "view-scheda-prodotto" */ "./views/area-tecnica/schedaProdotto.jsx"
  )
);

/** AREA SOFTWARE */
const RequistiSoftware = Loadable(() =>
  import(
    /* webpackChunkName: "view-requisiti-software" */ "./views/software/requisitiSoftware.jsx"
  )
);

const MetronInstaller = Loadable(() =>
  import(
    /* webpackChunkName: "view-metron-installer" */ "./views/software/metronInstaller.jsx"
  )
);

const ChatbotAssistenzaMetron = Loadable(() =>
  import(
    /* webpackChunkName: "view-chatbot-assistenza-metron" */ "./views/software/chatbotAssistenzaMetron.jsx"
  )
);

/** SUPPORTO */
const RecapitiEServizi = Loadable(() =>
  import(
    /* webpackChunkName: "view-recapiti-servizi" */ "./views/company-info/recapitiServizi.jsx"
  )
);


const CompanyInformation = Loadable(() =>
  import(
    /* webpackChunkName: "view-company-information" */ "./views/company-info/companyInformation.jsx"
  )
);

const GeneralSellCondition = Loadable(() =>
  import(
    /* webpackChunkName: "view-general-sell-condition" */ "./views/company-info/generalSellCondition.jsx"
  )
);

const Tutorial = Loadable(() =>
  import(/* webpackChunkName: "view-tutorial" */ "./views/tutorial/tutorial.jsx")
);

const Assistenza = Loadable(() =>
  import(/* webpackChunkName: "view-assistenza" */ "./views/assistenza/assistenza.jsx")
);

const Booking = Loadable(() =>
  import(/* webpackChunkName: "view-booking" */ "./views/booking/booking.jsx")
);

/** STATISTICHE */
const Statistiche = Loadable(() =>
  import(/* webpackChunkName: "view-statistiche" */ "./views/statistiche/statistiche.jsx")
);

/** LISTA UTENTI */
const ListaUtenti = Loadable(() =>
  import(/* webpackChunkName: "view-user-list" */"./views/utenti/list.jsx")
);

/*** ACADEMY **********/
/****** OLD VERSION ***/
const Academy = Loadable(() =>
  import(/* webpackChunkName: "view-academy" */ "./views/academy/academy.jsx")
);

/****** NEW VERSION ***/
const VideoAcademy = Loadable(() =>
  import(/* webpackChunkName: "view-academy-video-list" */ "./views/academy/videoList.jsx")
);

const VideoAcademyDettaglio = Loadable(() =>
  import(
    /* webpackChunkName: "view-video-academy-dettaglio" */ "./views/academy/videoAcademyDettaglio.jsx"
  )
);

const VideoAcademyCategoria = Loadable(() =>
  import(
    /* webpackChunkName: "view-video-by-category" */ "./views/academy/videoByCategory.jsx"
  )
);

/** AREA DOWNLOAD */
const AreaDownload = Loadable(() =>
  import(
    /* webpackChunkName: "view-area-download" */ "./views/area-download/areaDownload.jsx"
  )
);
const AreaDownloadPdf = Loadable(() =>
  import(
    /* webpackChunkName: "view-area-download-pdf" */ "./views/area-download/areaDownloadPdf.jsx"
  )
);

/** ACADEMY NEWSLETTER */
const CreateNewsletter = Loadable(() =>
  import(/* webpackChunkName: "view-newsletter-create" */ "./views/newsletter/create.jsx")
);

const ListNewsletter = Loadable(() =>
  import(
    /* webpackChunkName: "view-newsletter-list" */ "./views/newsletter/list.jsx"
  )
);

const NewsletterSubscribers = Loadable(() =>
  import(
    /* webpackChunkName: "view-newsletter-subscribers" */ "./views/newsletter/subscribers.jsx"
  )
);

const EditNewsletter = Loadable(() =>
  import(
    /* webpackChunkName: "view-newsletter-edit" */ "./views/newsletter/edit.jsx"
  )
);

const NewsletterSendState = Loadable(() =>
  import(/* webpackChunkName: "view-newsletter-send-state" */ "./views/newsletter/sendState.jsx")
);

const views = {
  Dashboard,
  ClientiArchivio,
  ClientiDettaglio,
  OrdiniArchivio,
  OrdiniAttivi,
  OrdiniCampioni,
  ArchiviOrdiniESostituzioniConNoteDaLeggere,
  ArchiviOrdiniESostituzioniDaConfermare,
  ConfermaOtpRichiestaConfermaOrdine,
  ConfermaEldomOutOfstock,
  OrderTracking,
  DamageReportComponentsList,
  DamageReportDetail,
  ConfermaOtpAap,
  OrdiniNoteAssistenza,
  OrdiniGaranzieDaAttivare,
  PrevisioneSpedizioniArchivio,
  Expo,
  OrdiniDettaglio,
  OrdiniTickets,
  SostituzioniArchivio,
  SostituzioniAttive,
  ReclamiArchivio,
  ReclamiNuovoReclamo,
  ReclamiDettaglio,
  SegnalazioneNuovoDanno,
  ListaProdotti,
  DettaglioProdotto,
  Carrello,
  StoricoCarrelli,
  StoricoCarrelloDettaglio,
  CommleListaProdottiMarketing,
  CommleListaProdottiOmaggio,
  CommleCarrelloOmaggi,
  CommleCarrelloMarketing,
  CommleCarrelloCampionari,
  CommleListaProdottiCampionarioAnte,
  CommleCarrelloAnte,
  CommleListaContrattiCampionari,
  CommleListaProdottiCampionari,
  CommleListaOrdiniOggettistica,
  CommleListaProdottiOggettistica,
  CommleCarrelloOggettistica,
  CommleCarrelloParzialeOggettistica,
  CommleCarrelloStoricoOrdini,
  CommleDistribuzioneOrdiniPopLista,
  CommleDistribuzioneOrdiniPopListaDettaglio,
  FattureArchivio,
  FattureNoteAccredito,
  AutorizzazioniReso,
  DdtArchivio,
  PromozioniArchivio,
  VirtualTourScorze,
  VirtualTourMilano,
  SchedeMontaggioHome,
  SchedeMontaggioCategory,
  SchedeMontaggioPdf,
  SchedeMontaggioVideo,
  ManualiTecnici,
  ManualiTecniciCategory,
  ManualiTecniciPdf,
  ManualiTecniciVideo,
  ManualiTecniciGallery,
  SchedaProdotto,
  RequistiSoftware,
  MetronInstaller,
  ChatbotAssistenzaMetron,
  RecapitiEServizi,
  CompanyInformation,
  GeneralSellCondition,
  Tutorial,
  Statistiche,
  ListaUtenti,
  Assistenza,
  Academy,
  VideoAcademy,
  VideoAcademyDettaglio,
  VideoAcademyCategoria,
  AreaDownload,
  Booking,
  AreaDownloadPdf,
  CreateNewsletter,
  ListNewsletter,
  NewsletterSubscribers,
  EditNewsletter,
  NewsletterSendState,
  Finiture,
  FinitureAnte,
  FinitureTop,
  FinitureAnteModello,
};

export default views;
